import { render, staticRenderFns } from "./KongmingLantern.vue?vue&type=template&id=2d52ea54&scoped=true&"
import script from "./KongmingLantern.vue?vue&type=script&lang=js&"
export * from "./KongmingLantern.vue?vue&type=script&lang=js&"
import style0 from "./KongmingLantern.vue?vue&type=style&index=0&id=2d52ea54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52ea54",
  null
  
)

export default component.exports